import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { DataGridPremium as DataGrid, GridColDef } from '@mui/x-data-grid-premium';
import { EstateTaskInstance } from 'queries';

import Modal from 'common/modal';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';

import { useStyles } from './estate-search-task-instances-modal.styles';

type Props = {
  modalOpen: boolean;
  setShowModal: (value: boolean) => void;
  estateSearchTaskInstances: EstateTaskInstance[];
  estateTaskColumns: GridColDef[];
  featureSubscriptionTypeLoading: boolean;
};

export const EstateSearchTaskInstancesModal = ({
  modalOpen,
  setShowModal,
  estateSearchTaskInstances,
  estateTaskColumns,
  featureSubscriptionTypeLoading,
}: Props) => {
  const classes = useStyles();

  const handleClose = () => {
    setShowModal(false);
  };

  const filteredEstateSearchTaskInstances = useMemo(
    () => estateSearchTaskInstances.filter((instance) => !instance.isHidden),
    [estateSearchTaskInstances],
  );

  if (!estateSearchTaskInstances) {
    showAlert({
      message: 'Error loading the Estate Search Task Instances!',
      severity: NotificationSeverity.ERROR,
    });
  }

  return (
    <Box className={classes.container}>
      <Modal
        setShowModal={setShowModal}
        onExitClick={handleClose}
        showModal={modalOpen}
        showActions={false}
        maxWidth="lg"
        overrideDialogStyles={{ zIndex: 1200 }}
        content={
          <>
            <Typography className={classes.heading} variant="h5">
              {estateSearchTaskInstances[0]?.shortName}
            </Typography>
            <DataGrid
              loading={featureSubscriptionTypeLoading}
              className={classes.estateTaskDataGrid}
              columns={estateTaskColumns}
              rows={filteredEstateSearchTaskInstances}
              disableColumnReorder
              disableRowSelectionOnClick
              disableColumnMenu
              hideFooter
              keepNonExistentRowsSelected
              getRowHeight={() => 'auto'}
              autoHeight
            />
          </>
        }
      />
    </Box>
  );
};
